import { ModelBase } from '@/models/model';

class InvoiceHistory extends ModelBase {
  static namespace = 'invoice_history';
}

export default InvoiceHistory.register();
